import { Controller } from "@hotwired/stimulus"

// Swaps a broken image for its placeholder sibling.
//
// The error event can fire before this controller connects (a cached broken
// image, for one), so connect() checks for an image that already failed.
export default class extends Controller {
  static targets = ["image", "placeholder"]

  connect() {
    const image = this.imageTarget
    if (image.complete && image.naturalWidth === 0) this.fallback()
  }

  fallback() {
    this.imageTarget.classList.add("hidden")
    this.placeholderTarget.classList.remove("hidden")
    this.placeholderTarget.classList.add("flex")
  }
}
